<template>
    <div class="min-h-screen flex items-center justify-center">
        <Form @submit="handleReset" :validation-schema="schema" class="card-primary max-w-sm mx-auto p-4 mt-10">

            <h2 class="text-lg font-bold mb-4 text-center">Définir un nouveau mot de passe</h2>

            <!-- Nouveau mot de passe -->
            <Field name="password" type="password" placeholder="Nouveau mot de passe"
                class="w-full px-3 py-2 border rounded mb-2" />
            <ErrorMessage name="password" class="text-fun text-sm mb-2" />

            <!-- Confirmation -->
            <Field name="confirmPassword" type="password" placeholder="Confirmez le mot de passe"
                class="w-full px-3 py-2 border rounded mb-2" />
            <ErrorMessage name="confirmPassword" class="text-fun text-sm mb-2" />

            <!-- Bouton -->
            <button v-if="!success" type="submit" class="btn-primary w-full mt-3" :disabled="loading">
                {{ loading ? "Réinitialisation..." : "Changer le mot de passe" }}
            </button>

            <p v-if="message" :class="{ 'text-green-600': success, 'text-red-600': !success }"
                class="text-sm mt-3 text-center">{{ message }}</p>

            <button v-if="success" type="button" class="btn-accent w-full mt-3"
                @click="router.push({ name: 'LoginRegister', query: { view: 'login' } })">
                Retour à la connexion
            </button>
        </Form>
    </div>
</template>

<script setup>
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

const route = useRoute()
const router = useRouter()

const loading = ref(false)
const message = ref(null)
const success = ref(false)

const schema = yup.object({
    password: yup.string().min(8, "8 caractères minimum").required("Mot de passe requis"),
    confirmPassword: yup.string()
        .oneOf([yup.ref("password"), null], "Les mots de passe doivent correspondre")
        .required("Confirmation requise"),
})

async function handleReset({ password }) {
    loading.value = true
    message.value = null

    try {
        const token = route.query.token
        if (!token) throw new Error("Token manquant")

        await axios.post('/api/auth/reset-password', { token, newPassword: password })

        message.value = "✅ Mot de passe réinitialisé avec succès."
        success.value = true

        setTimeout(() => router.push({ name: 'LoginRegister', query: { view: 'login' } }), 2000)
    } catch (err) {
        message.value = err.response?.data?.message || "Lien invalide ou expiré."
        success.value = false
    } finally {
        loading.value = false
    }
}
</script>
